export default __webpack_public_path__ + "static/media/oliver-peoples-1.8dc4b343.png";